import { StaticErrorMessage } from 'enums/Messages';

const pascalCaseToReadable = (value: string): string => {
  const isLetter = /^[a-zA-Z]$/;

  return value.split('').reduce((acc, curr) => {
    if (!isLetter.test(curr)) {
      return acc.concat(curr);
    }

    const lastChar = acc.at(-1);
    const isCapitalizedPrev =
      lastChar && isLetter.test(lastChar) && lastChar === lastChar.toUpperCase();

    if (!isCapitalizedPrev && acc && curr.toUpperCase() === curr) {
      return acc.concat(' ', curr);
    }

    return acc.concat(curr);
  }, '');
};

export const getIsRequiredMessage = (name: string) => {
  const readableName = pascalCaseToReadable(name);

  return `${readableName.replace('*', '')} ${StaticErrorMessage.Required}`;
};

export const isMaxLength = (digit: number | string) => `Must include ${digit} digits`;
export const isMinLength = (digit: number | string) => `Must include at least ${digit} characters`;
